<template>
  <div class="p-2 sm:p-3">
    <div class="flex justify-center flex-wrap">
      <!-- Left section -->
      <div class="min-w-full sm:min-w-30 max-w-2xl m-2 flex-1">
        <div class="bg-white rounded-lg shadow-card px-4 py-8 sm:p-12">
          <h1 class="font-semibold text-xl text-center">
            Advertise your event planning or supplier business with BuildaBox.co. Add your info, products and services and that's it. No fees. No credit cards needed. 
          </h1>
          <form @submit.prevent="submit" class="mt-10">
            <fieldset>
              <label for="name">Business Name<small>*</small></label>
              <input
                type="text"
                class="input mt-2"
                id="name"
                v-model="form.name"
                required
              />
            </fieldset>

            <fieldset class="mt-4">
              <label for="description">Description<small>*</small></label>
              <textarea
                class="textarea mt-2"
                id="description"
                v-model="form.description"
                required
              />
            </fieldset>

            <fieldset class="mt-4">
              <label for="description">Services<small>*</small></label>
              <multiselect
                class="mt-2"
                v-model="form.services"
                :options="services"
                :multiple="true"
                track-by="id"
                label="name"
              />
            </fieldset>

            <fieldset class="mt-4">
              <label class="">Company logo*</label>

              <file-picker
                type="image"
                :value="form.logo"
                @change="imageSelected"
              />
            </fieldset>

            <div class="mt-4 flex flex-col md:flex-row">
              <fieldset class="flex-1">
                <label for="contact_first_name"
                  >Contact First Name<small>*</small></label
                >
                <input
                  type="text"
                  class="input mt-2"
                  id="contact_first_name"
                  name="contact_first_name"
                  v-model="form.contact_first_name"
                  required
                />
              </fieldset>
              <fieldset class="flex-1 mt-4 md:mt-0 ml-0 md:ml-4">
                <label for="contact_last_name"
                  >Contact Last Name<small>*</small></label
                >
                <input
                  type="text"
                  class="input mt-2"
                  id="contact_last_name"
                  name="contact_last_name"
                  v-model="form.contact_last_name"
                  required
                />
              </fieldset>
            </div>

            <fieldset class="mt-4">
              <label for="email">Email<small>*</small></label>
              <input
                type="text"
                class="input mt-2"
                id="email"
                name="email"
                v-model="form.email"
                required
              />
            </fieldset>

            <fieldset class="mt-4">
              <label for="address">Address<small>*</small></label>
              <input
                type="text"
                class="input mt-2"
                id="address"
                name="address"
                v-model="form.address"
                required
              />
            </fieldset>

            <fieldset class="mt-5">
              <label for="city">City<small>*</small></label>
              <input
                type="text"
                class="input mt-2"
                id="city"
                name="city"
                v-model="form.city"
                required
              />
            </fieldset>

            <fieldset class="mt-5">
              <label for="state">State<small>*</small></label>
              <input
                type="text"
                class="input mt-2"
                id="state"
                name="state"
                v-model="form.state"
                required
              />
            </fieldset>

            <fieldset class="mt-5">
              <label for="zip">Zip<small>*</small></label>
              <input
                type="text"
                class="input mt-2"
                id="zip"
                name="zip"
                v-model="form.zip"
                required
              />
            </fieldset>

            <fieldset class="mt-5">
              <label for="phone">Phone<small>*</small></label>
              <input
                type="tel"
                class="input mt-2"
                id="phone"
                name="phone"
                v-model="form.phone"
                required
              />
            </fieldset>

            <fieldset class="mt-5">
              <label for="locations"
                >Enter Zip Codes that the Business Services<small
                  >*</small
                ></label
              >
              <vue-tags-input
                class="mt-2"
                v-model="tag"
                :tags="form.service_zip_codes"
                @tags-changed="locations => onUpdateLocations(locations)"
                @before-adding-tag="validateLocation"
                @before-deleting-tag="location => onDeleteLocationTag(location)"
                placeholder="type postal code and press enter"
              >
              </vue-tags-input>
              <p v-if="isLocationNotValid" class="text-red-600 mt-1">The provided data is not valid</p>
            </fieldset>

            <fieldset class="mt-5">
              <div>
                <span class="mr-2">Postal Codes Selected:</span
                ><span class="font-semibold">{{ zipCodesCount }}</span>
              </div>

              <div
                v-if="priceDetails && priceDetails.length > 0"
                class="details mt-4 mb-4 border border-1 rounded"
              >
                <div class="grid gap-3 grid-cols-3 p-2 bg-gray-100">
                  <span class="text-sm">Zip</span>
                  <span class="text-sm">Price</span>
                  <span class="text-sm"></span>
                </div>

                <div
                  v-for="(row, index) in priceDetails"
                  :key="index"
                  class="grid gap-3 grid-cols-3 border-t p-2"
                >
                  <span class="text-sm">{{ row.location }}</span>
                  <span class="text-sm">{{ row.price | currencyFormat }}</span>
                  <span class="text-centera"
                    ><button
                      @click.prevent="onRemoveLocation(row.location)"
                      class="bg-red-400 px-4 mx-auto rounded text-white font-semibold hover:bg-red-600"
                    >
                      x
                    </button></span
                  >
                </div>
              </div>

              <div v-if="price > 0" class="mt-4">
                <span class="mr-2">Total Price:</span
                ><span class="font-semibold">{{ zipCodesPriceFormatted }}</span>
              </div>
            </fieldset>

            <div class="mt-4">
              <p class="text-sm">
                Advertise your event planning or event supplies across multiple postal codes for free. 
              </p>
            </div>

            <fieldset class="mt-16">
              <div class="flex flex-col-reverse sm:flex-row justify-between">
                <button
                  class="btn btn-secondary font-semibold rounded-lg px-10 min-w-10 mt-5 sm:mt-0"
                  type="button"
                  @click="$emit('back')"
                >
                  <span>Back</span>
                </button>
                <button
                  class="btn btn-primary font-semibold rounded-lg px-10 min-w-10"
                  type="submit"
                  :disabled="!canSubmit"
                  :title="invalid"
                >
                  <span v-if="!progressSaving">Next</span>
                  <Spinner class="mx-auto" v-if="progressSaving" />
                </button>
              </div>
            </fieldset>
          </form>
        </div>
      </div>

      <!-- Right section infoboxes -->
      <div class="m-2">
        <info-box :showIcon="true">
          Welcome to the Event Business Setup flow. Add your business info to create a free listing in BuildaBox.co. Add postal codes as territories, products and services that will all be found by event owners, planners and coordinators.
        </info-box>

      </div>
    </div>
  </div>
</template>

<script>
import Spinner from "@/components/common/Spinner";
import Api from "@/api/api_v1.0";
import { required } from "vuelidate/lib/validators";
import InfoBox from "@/components/common/InfoBox.vue";
import VueTagsInput from "@johmun/vue-tags-input";
import { mapGetters, mapActions } from "vuex";
import FilePicker from "@/components/common/controls/FilePicker.vue";
import Multiselect from "vue-multiselect";

export default {
  name: "EventPlannerDetails",
  components: {
    Spinner,
    InfoBox,
    VueTagsInput,
    FilePicker,
    Multiselect,
  },
  data() {
    return {
      showPriceListModal: true,
      price: 0,
      priceDetails: [],
      updateMode: 0,
      tag: "",
      isLocationNotValid: false,
      progressSaving: false,
      logo_file: "",
      form: {
        id: null,
        name: "",
        email: "",
        description: "",
        address: "",
        contact_first_name: "",
        contact_last_name: "",
        phone: "",
        zip: "",
        state: "",
        city: "",
        service_zip_codes: [],
        logo: "",
        services: []
      },
      services: []
    };
  },


  computed: {
    ...mapGetters(["eventPlannerDetails", "isAuthenticated", "personalDetails"]),

    zipCodesCount() {
      return this.form.service_zip_codes.length;
    },

    locations() {
      return this.parseLocations(this.form.service_zip_codes);
    },


    zipCodesPriceFormatted() {
      return this.price > 0 ? '$' + this.price : 'free';
    },

    canSubmit() {
      return !this.$v.$invalid;
    },

    logo() {
      return this.logo_file || this.form.logo;
    },

    epUUID() {
      const uuid = this.$route.params.uuid;
      return (uuid && uuid != 'new') ? uuid : false
    },

    invalid() {
      const fields = {
        name: "Name",
        address: "Address",
        city: "City",
        contact_first_name: "Contact First Name",
        contact_last_name: "Contact Last Name",
        description: "Description",
        phone: "Phone",
        services: "Services",
        state: "State",
        zip: "Zip Code",
        email: "Email",
      };

      let invalid = [];
      for (let a in fields) {
        if (this.$v.form[a].$invalid) {
          invalid.push(fields[a]);
        }
      }

      if (this.$v.logo.$invalid) {
        invalid.push('Logo');
      }

      return invalid.length > 0 ? "Please, fill before next fields: " + invalid.join(', ') : false;
    }
  },
  validations: {
    form: {
      name: { required },
      email: { required },
      description: { required },
      address: { required },
      contact_first_name: { required },
      contact_last_name: { required },
      phone: { required },
      zip: { required },
      state: { required },
      city: { required },
      services: { required }
    },
    logo: { required }
  },

  beforeCreate() {
    this.$root.$on("eventPlannerTrySubmitStep", () => this.trySubmit());
  },
  beforeDestroy() {
    this.$root.$off("eventPlannerTrySubmitStep", () => this.trySubmit());
  },

  async mounted() {
    this.getEventPlannerServices();

    // if come back from categories => try load from vuex
    if (this.eventPlannerDetails) {
      for(let a in this.eventPlannerDetails) {
        this.form[a] = this.eventPlannerDetails[a];
      }
    }


    // if from invitation caterer email - token should be available. Try to login
    if (this.$route.query.token) {
      const loginResponse = await Api.loginAsEventPlanner({
        token: this.$route.query.token
      });

      if (loginResponse.status == 200) {
        this.$store.commit("SET_AUTH_DATA", {
          user: loginResponse.data.data,
          token: loginResponse.data.token
        });
      }
    }


    let timer = setInterval(async () => {
      if(this.personalDetails !== null) {
        clearInterval(timer);

        if (this.isAuthenticated && this.epUUID) {
          try {
            const response = await Api.getMyBusinessEventPlannerDetails(this.epUUID);
            this.form = response.data;
            this.$nextTick(() => {
              this.$store.commit("setEventPlannerDetails", response.data);
              this.getLocationsPrice();
              this.updateMode = 1;
            });
          } catch (err) {
            console.error(err)
          }
        }

      }

    }, 500);


  },

  methods: {
    ...mapActions(["setSuccessMessage", "setErrorMessage"]),

    validateLocation(data) {
      if ( ! /^\d+$/.test(data.tag.text)  ) {
        this.isLocationNotValid = true;
        setTimeout( () => {
          this.tag = "";
          this.isLocationNotValid = false;
        }, 4000)
      } else {
        this.isLocationNotValid = false;
        data.addTag();
      }
    },

    onDeleteLocationTag(location) {
      if(this.eventPlannerDetails?.id) {
        Api.removeEventPlannerLocation(this.eventPlannerDetails?.id, location.tag.text);
      }

      this.deleteLocationLocally(location.tag.text);

      location.deleteTag();

    },

    onRemoveLocation(location) {
      if(this.eventPlannerDetails?.id) {
        Api.removeEventPlannerLocation(this.eventPlannerDetails?.id, location);
      }

      this.deleteLocationLocally(location);

      this.getLocationsPrice();
    },

    deleteLocationLocally($location) {
      const index = this.form.service_zip_codes.indexOf(this.form.service_zip_codes.find( item => {
        return item.text == location
      }));

      this.form.service_zip_codes.splice(index, 1);
    },

    parseLocations(data) {
      return data.map( zip => { return zip.text});
    },

    onUpdateLocations(data) {
      this.form.service_zip_codes = data;

      this.getLocationsPrice();
    },

    async getLocationsPrice() {
      const data = {
        locations: this.parseLocations(this.form.service_zip_codes),
      }

      if (this.form.id) {
        data['event_planner_id'] = this.form.id
      }

      const response = await Api.getEventPlannerLocationsPrice(data);

      this.price = response.data.total;
      this.priceDetails = response.data.prices;
    },

    imageSelected(file) {
      this.logo_file = file;
    },

    prepareFormData() {
      let form = new FormData();

      for (let a in this.form) {
        if (!this.form[a]) continue;

        if (a == "service_zip_codes" || a == "services") {
          form.append(a, JSON.stringify(this.form[a]));
        } else {
          form.append(a, this.form[a]);
        }
      }

      if (this.logo_file) {
        form.append("logo_file", this.logo_file);
      }

      return form;
    },

    trySubmit() {
      if (this.canSubmit) {
        this.submit();
      } else {
        this.setErrorMessage("Please complete all required fields before saving. ");
      }
    },

    async submit() {
      this.progressSaving = true;

      try {
        const response = await Api.storeEventPlanner(this.prepareFormData());
        this.form.id = response.data.id;
        await this.$store.commit("setEventPlannerDetails", response.data);

        // If is logged in - assign caterer to user
        await this.tryLinkEPToUser();


        this.progressSaving = false;
        this.$emit("nextButtonPressed");
      } catch (err) {
        this.progressSaving = false;
        console.error(err)
      }
    },

    async tryLinkEPToUser() {
      if (this.isAuthenticated) {

        this.$gtm.trackEvent({
          event: "evplanner_registered",
          category: "Evplanner",
          action: "evplannerRegistered",
          label: "New Event Planner Registered",
          value: this.personalDetails.email
        });

        await Api.linkEPToUser(this.eventPlannerDetails.id);

        const ep = this.eventPlannerDetails;
        ep.user_id = this.personalDetails.id;
        this.$store.commit("setEventPlannerDetails", ep);

        await this.$store.dispatch('getPersonalDetails');
      }
    },

    async getEventPlannerServices() {
      try {
        const response = await Api.getEventPlannerServices()
        this.services = response.data
      } catch (err) {
        console.error(err)
      }
    }
  }
};
</script>

<style>
@import "~vue-multiselect/dist/vue-multiselect.min.css";

.multiselect {
  color: initial;
}

.multiselect__tags {
  background: white;
  border: 1px solid #e0e2e9;
  border-radius: 8px;
  padding: 11px 1rem 0 1rem;
  font-size: initial;
  min-height: 50px;
}

.multiselect__select {
  height: 50px;
}

.multiselect__input,
.multiselect__single {
  margin: 0;
  padding: 0;
  min-height: auto;
}

.multiselect__placeholder {
  margin-bottom: 0;
  padding-top: 0;
  line-height: 1;
  vertical-align: middle;
}

.multiselect__input,
.multiselect__single {
  line-height: 1;
  vertical-align: middle;
}

.multiselect__content-wrapper {
  border-color: #e0e2e9;
}

.multiselect__tag {
  background-color: #f75f39;
}

.multiselect__tag-icon:after {
  color: white;
}
</style>
